import React from "react";

const Footer = () => {
  return <div className="footer">Derechos Reservados</div>;
};

export default Footer;
